import React from "react";
import { forwardRef } from "react";
import { Icon, IconProps } from "./common";

const Desk: Icon = forwardRef<SVGSVGElement, IconProps>(({ color = "currentColor", size = 20, ...rest }, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
   <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M2.5 16V4h9m6 12v-4m-6-8h6v4m-6-4v4m6 4h-6V8m6 4V8m-6 0h6" />
   <path stroke={color} strokeLinecap="round" d="M13.5 6h2M13.5 10h2" />
</svg>);

export default Desk;